<template>
  <div class="kiosks">
    <h1 v-if="no_kiosk">Invalid Kiosk Slug</h1>
  </div>
</template>

<script>
import { db, functions } from "@/config/firebaseInit";
export default {
  name: "home",
  components: {},
  data() {
    return {
      no_kiosk: false,
      getLocations: functions.httpsCallable("formatAllListingsScheduledCall"),
    };
  },
  filters: {
    address_format(val) {
      try {
        return `${val.address_1} ${val.address_2} ${val.address_3}. ${val.city} ${val.state} ${val.zip}`;
      } catch (err) {
        return "INVALID";
      }
    },
  },
  created() {
    // this.getLocations();
    if (this.$route.params.client_slug) {
      this.initiateClientKiosk();
    } else {
      this.no_kiosk = true;
    }
  },
  methods: {
    async initiateClientKiosk() {
      localStorage.clear();
      let kiosk = await db
        .collectionGroup("kiosk")
        .where("slug", "==", this.$route.params.kiosk_slug)
        .where("client_slug", "==", this.$route.params.client_slug)
        .get()
        .then((snap) => {
          if (snap.docs.length) {
            let kiosk_data = snap.docs[0].data();
            kiosk_data.id = snap.docs[0].id;
            this.$store.commit("setKiosk", kiosk_data);
            return kiosk_data;
          } else {
            this.no_kiosk = true;
            return false;
          }
        });
      await db
        .collection("client")
        .doc(kiosk.client_id)
        .get()
        .then((doc) => {
          if (doc.exists) {
            let client_data = doc.data();
            client_data.id = doc.id;
            this.$store.commit("setClient", client_data);
            this.$store.dispatch("updateClient");
            this.$router.push({ path: "/" });
            return true;
          } else {
            this.no_kiosk = true;
          }
        });
    },
  },
};
</script>

<style lang="scss">
.kiosks {
  padding: 100px;
  max-width: 1200px;
  margin: auto;
  h1 {
    width: 100%;
    text-align: center;
    font-size: 50px;
    margin-top: 0;
    color: black;
  }
  .kiosk {
    background-color: white;
    border: 2px solid #eaeaea;
    padding: 20px;
    margin-bottom: 20px;
    p {
      margin: 0;
      font-size: 30px;
      &.name {
        font-size: 40px;
        font-weight: bold;
      }
    }
  }
}
</style>
